export default new class CommentForm {
  constructor() {
    this.commentFormSelector = '_comment-form';
    this.commentPostInputSelector = '_comment-post-input';
    this.commentParentInputSelector = '_comment-parent-input';
    this.commentNameInputSelector = '_comment-name-input';
    this.commentEmailInputSelector = '_comment-email-input';
    this.formPrivacyPolicyInputSelector = '_comment-privacypolicy-input';
    this.commentMessageInputSelector = '_comment-message-textarea';
    this.submitBtnSelector = '_comment-submit';
    this.inValidSelector = '_invalid';
    this.successSelector = '_comment-success';
    this.preLoaderSelector = '_comment-form-preloader';
    this.delay = 2000;

    this.replyCommeny();

    $('body').on('click', `.${this.submitBtnSelector}`, () => {
      this.handler();
    });
  }

  handler() {
    const form = document.querySelector(`.${this.commentFormSelector}`);

    if (!form) return;
    setTimeout(() => {
      this.checkForm(form);
    }, 0);
  }

  checkForm(form) {
    const privacypolicy = form.querySelector(`.${this.formPrivacyPolicyInputSelector}`);
    if (privacypolicy.checked === false) {
      privacypolicy.focus();
      return;
    }
    const inputPost = form.querySelector(`.${this.commentPostInputSelector}`);
    const idPost = inputPost.value;

    const inputParent = form.querySelector(`.${this.commentParentInputSelector}`);
    const idParent = inputParent.value;

    const inputName = form.querySelector(`.${this.commentNameInputSelector}`);
    let name = '';
    if (inputName) {
      name = inputName.value;
    }

    const inputEmail = form.querySelector(`.${this.commentEmailInputSelector}`);
    let email = '';
    if (inputEmail) {
      email = inputEmail.value;
    }
    const inputComment = form.querySelector(`.${this.commentMessageInputSelector}`);
    const comment = inputComment.value;

    $.request('commentsItem::onSaveComment', {
      data: {
        idPost,
        idParent,
        name,
        email,
        comment,
      },
      loading: `.${this.preLoaderSelector}`,
      complete: (res) => {
        this.showSuccess(res);
        setTimeout(() => {
          inputName.value = '';
          inputParent.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          inputName.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          inputEmail.value = '';
          inputEmail.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          inputComment.value = '';
          inputComment.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          this.hideSuccess();
        }, this.delay);
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  replyCommeny() {
    $('body').on('click', '._reply-button', (e) => {
      const form = $(e.currentTarget);
      const id = form.attr('data-id');
      $(`#comment-${id}`).find('.comment-content').append($('#comment-form'));
      document.querySelector('#parent-id').value = id;
    });
  }

  showSuccess(res) {
    const { statusText } = res;
    if ((statusText === 'success') || (statusText === 'OK')) {
      $(`.${this.successSelector}`).addClass('show');
    }
  }

  hideSuccess() {
    $(`.${this.successSelector}`).removeClass('show');
  }
}();
